export const schemas = [
  {
    "title": "Balance",
    "type": "object",
    "properties": {
      "header": {
        "title": "Header",
        "default": {},
        "type": "object"
      },
      "values": {
        "title": "balance values",
        "default": [],
        "type": "array",
        "items": {}
      }
    }
  },
  {
    "title": "Balance_Comparison",
    "type": "object",
    "properties": {
      "header": {
        "title": "Header",
        "default": {},
        "type": "object"
      },
      "values": {
        "title": "balance of comparison values",
        "default": [],
        "type": "array",
        "items": {}
      },
      "min_use": {
        "title": "min of use range",
        "default": "",
        "type": "string"
      },
      "max_use": {
        "title": "max of use range",
        "default": "",
        "type": "string"
      }
    }
  },
  {
    "title": "BaseBlock",
    "type": "object",
    "properties": {
      "_id": {
        "title": "Identifier",
        "type": "string"
      },
      "_rev": {
        "title": "Revision number",
        "type": "string"
      },
      "created": {
        "title": "Creation timestamp",
        "type": "integer"
      },
      "updated": {
        "title": "Update timestamp",
        "type": "integer"
      },
      "doc_type": {
        "title": "selector identifier for db",
        "default": "baseblock",
        "type": "string"
      },
      "created_by": {
        "title": "author user id",
        "default": "",
        "type": "string"
      },
      "updated_by": {
        "title": "doc modifier user id",
        "default": "",
        "type": "string"
      },
      "version": {
        "title": "Version",
        "default": 2,
        "type": "integer"
      },
      "dismissed": {
        "title": "Dismissed",
        "default": false,
        "type": "boolean"
      },
      "name": {
        "title": "internal name",
        "default": "",
        "type": "string"
      },
      "template": {
        "title": "Template",
        "type": "string"
      },
      "family": {
        "title": "Family",
        "type": "string"
      },
      "label": {
        "title": "Label",
        "type": "string"
      },
      "op_types": {
        "title": "list of possible operations",
        "default": [],
        "type": "array",
        "items": {
          "type": "string"
        }
      },
      "revision": {
        "title": "Revision",
        "default": 0,
        "type": "integer"
      },
      "formulas": {
        "title": "list of formulas used in the block",
        "default": [],
        "type": "array",
        "items": {
          "type": "string"
        }
      },
      "category": {
        "title": "type of category used",
        "default": "",
        "type": "string"
      },
      "block_type": {
        "title": "type of block, for awi supermaster",
        "default": "general",
        "type": "string"
      },
      "domain": {
        "title": "User domain",
        "type": "string"
      },
      "conditional": {
        "title": "if the block has conditional values",
        "default": false,
        "type": "boolean"
      },
      "active": {
        "title": "if block is active",
        "default": true,
        "type": "boolean"
      }
    },
    "required": [
      "template",
      "family",
      "label"
    ]
  },
  {
    "title": "BaseModel",
    "type": "object",
    "properties": {}
  },
  {
    "title": "BlockList",
    "type": "object",
    "properties": {
      "block_list": {
        "title": "Block List",
        "default": [],
        "type": "array",
        "items": {
          "$ref": "#/definitions/BaseBlock"
        }
      }
    },
    "definitions": {
      "BaseBlock": {
        "title": "BaseBlock",
        "type": "object",
        "properties": {
          "_id": {
            "title": "Identifier",
            "type": "string"
          },
          "_rev": {
            "title": "Revision number",
            "type": "string"
          },
          "created": {
            "title": "Creation timestamp",
            "type": "integer"
          },
          "updated": {
            "title": "Update timestamp",
            "type": "integer"
          },
          "doc_type": {
            "title": "selector identifier for db",
            "default": "baseblock",
            "type": "string"
          },
          "created_by": {
            "title": "author user id",
            "default": "",
            "type": "string"
          },
          "updated_by": {
            "title": "doc modifier user id",
            "default": "",
            "type": "string"
          },
          "version": {
            "title": "Version",
            "default": 2,
            "type": "integer"
          },
          "dismissed": {
            "title": "Dismissed",
            "default": false,
            "type": "boolean"
          },
          "name": {
            "title": "internal name",
            "default": "",
            "type": "string"
          },
          "template": {
            "title": "Template",
            "type": "string"
          },
          "family": {
            "title": "Family",
            "type": "string"
          },
          "label": {
            "title": "Label",
            "type": "string"
          },
          "op_types": {
            "title": "list of possible operations",
            "default": [],
            "type": "array",
            "items": {
              "type": "string"
            }
          },
          "revision": {
            "title": "Revision",
            "default": 0,
            "type": "integer"
          },
          "formulas": {
            "title": "list of formulas used in the block",
            "default": [],
            "type": "array",
            "items": {
              "type": "string"
            }
          },
          "category": {
            "title": "type of category used",
            "default": "",
            "type": "string"
          },
          "block_type": {
            "title": "type of block, for awi supermaster",
            "default": "general",
            "type": "string"
          },
          "domain": {
            "title": "User domain",
            "type": "string"
          },
          "conditional": {
            "title": "if the block has conditional values",
            "default": false,
            "type": "boolean"
          },
          "active": {
            "title": "if block is active",
            "default": true,
            "type": "boolean"
          }
        },
        "required": [
          "template",
          "family",
          "label"
        ]
      }
    }
  },
  {
    "title": "BulkFormulas",
    "type": "object",
    "properties": {
      "bulk_formulas": {
        "title": "Bulk Formulas",
        "default": [],
        "type": "array",
        "items": {
          "$ref": "#/definitions/Formula"
        }
      }
    },
    "definitions": {
      "Formula": {
        "title": "Formula",
        "type": "object",
        "properties": {
          "_id": {
            "title": "Identifier",
            "type": "string"
          },
          "_rev": {
            "title": "Revision number",
            "type": "string"
          },
          "created": {
            "title": "Creation timestamp",
            "type": "integer"
          },
          "updated": {
            "title": "Update timestamp",
            "type": "integer"
          },
          "doc_type": {
            "title": "selector identifier for db",
            "default": "formula",
            "type": "string"
          },
          "created_by": {
            "title": "author user id",
            "default": "",
            "type": "string"
          },
          "updated_by": {
            "title": "doc modifier user id",
            "default": "",
            "type": "string"
          },
          "version": {
            "title": "Version",
            "default": 2,
            "type": "integer"
          },
          "dismissed": {
            "title": "Dismissed",
            "default": false,
            "type": "boolean"
          },
          "equation": {
            "title": "equation to solve",
            "default": "",
            "type": "string"
          },
          "data": {
            "title": "paramters to use in the equation | array of values for the equation",
            "default": {},
            "type": "object"
          },
          "fixed_params": {
            "title": "if the parameter number is fixed or not (see stdev)",
            "default": false,
            "type": "boolean"
          },
          "notes": {
            "title": "notes or equation explanation",
            "default": "",
            "type": "string"
          }
        }
      }
    }
  },
  {
    "title": "Category",
    "type": "object",
    "properties": {
      "_id": {
        "title": "Identifier",
        "type": "string"
      },
      "_rev": {
        "title": "Revision number",
        "type": "string"
      },
      "created": {
        "title": "Creation timestamp",
        "type": "integer"
      },
      "updated": {
        "title": "Update timestamp",
        "type": "integer"
      },
      "doc_type": {
        "title": "Doc Type",
        "default": "category",
        "type": "string"
      },
      "created_by": {
        "title": "author user id",
        "default": "",
        "type": "string"
      },
      "updated_by": {
        "title": "doc modifier user id",
        "default": "",
        "type": "string"
      },
      "version": {
        "title": "Version",
        "default": 2,
        "type": "integer"
      },
      "dismissed": {
        "title": "Dismissed",
        "default": false,
        "type": "boolean"
      },
      "name": {
        "title": "category name",
        "default": "",
        "type": "string"
      },
      "family": {
        "title": "instrument family",
        "default": "",
        "type": "string"
      },
      "uom": {
        "title": "unit of measure",
        "default": "",
        "type": "string"
      },
      "iso": {
        "title": "values of the iso",
        "default": {},
        "type": "object"
      },
      "leg": {
        "title": "values of the leg",
        "default": {},
        "type": "object"
      },
      "iso_simple": {
        "title": "values of the iso simple",
        "default": {},
        "type": "object"
      },
      "lat": {
        "title": "values of the lat",
        "default": {},
        "type": "object"
      }
    }
  },
  {
    "title": "CategoryBlock",
    "type": "object",
    "properties": {
      "cat_type": {
        "title": "Cat Type",
        "default": "multiple",
        "type": "string"
      },
      "label": {
        "title": "label of the block",
        "default": "",
        "type": "string"
      },
      "name": {
        "title": "name of the block",
        "default": "",
        "type": "string"
      },
      "calc_value": {
        "title": "calculated value",
        "default": false,
        "type": "boolean"
      },
      "trials": {
        "title": "trial numeber values",
        "default": [],
        "type": "array",
        "items": {}
      }
    }
  },
  {
    "title": "CategoryBlockSingleVal",
    "type": "object",
    "properties": {
      "cat_type": {
        "title": "Cat Type",
        "default": "single",
        "type": "string"
      },
      "label": {
        "title": "label of the block",
        "default": "",
        "type": "string"
      },
      "name": {
        "title": "name of the block",
        "default": "",
        "type": "string"
      },
      "calc_value": {
        "title": "calculated value",
        "default": false,
        "type": "boolean"
      },
      "value": {
        "title": "value of the trials",
        "default": "",
        "type": "string"
      }
    }
  },
  {
    "title": "Client",
    "type": "object",
    "properties": {
      "external_id": {
        "title": "external key used by instruments",
        "default": "",
        "type": "string"
      },
      "external_rev": {
        "title": "idempiere last revision",
        "type": "integer"
      },
      "updated_sync": {
        "title": "last sync time idempiere",
        "default": 0,
        "type": "integer"
      },
      "IE_time": {
        "title": "IE time MUST BE SAME AS UPDATED EACH IE",
        "type": "integer"
      },
      "ide_conflict": {
        "title": "if there is a conflict with idempiere",
        "default": false,
        "type": "boolean"
      },
      "_id": {
        "title": "Identifier",
        "type": "string"
      },
      "_rev": {
        "title": "Revision number",
        "type": "string"
      },
      "created": {
        "title": "Creation timestamp",
        "type": "integer"
      },
      "updated": {
        "title": "Update timestamp",
        "type": "integer"
      },
      "doc_type": {
        "title": "selector identifier for db",
        "default": "client",
        "type": "string"
      },
      "created_by": {
        "title": "author user id",
        "default": "",
        "type": "string"
      },
      "updated_by": {
        "title": "doc modifier user id",
        "default": "",
        "type": "string"
      },
      "version": {
        "title": "Version",
        "default": 2,
        "type": "integer"
      },
      "dismissed": {
        "title": "Dismissed",
        "default": false,
        "type": "boolean"
      },
      "name": {
        "title": "client name",
        "default": "",
        "type": "string"
      },
      "piva": {
        "title": "client VAT",
        "type": "string"
      },
      "contacts": {
        "title": "address book",
        "default": {},
        "type": "object",
        "additionalProperties": {
          "$ref": "#/definitions/Contact"
        }
      },
      "complete": {
        "title": "complete flag",
        "default": false,
        "type": "boolean"
      },
      "owner": {
        "title": "client owner id",
        "default": "",
        "type": "string"
      },
      "active": {
        "title": "true => client is active, deactivate => not visible",
        "default": true,
        "type": "boolean"
      },
      "is_partner": {
        "title": "true => is a billing partner",
        "default": false,
        "type": "boolean"
      },
      "domain": {
        "title": "User domain",
        "default": "",
        "type": "string"
      },
      "ref_orgs": {
        "title": "org_id list that operated on their instrument",
        "default": [],
        "type": "array",
        "items": {
          "type": "string"
        }
      },
      "fiscalcode": {
        "title": "fiscal code of the owner",
        "default": "",
        "type": "string"
      },
      "pec": {
        "title": "pec mail",
        "default": "",
        "type": "string"
      },
      "unique_code": {
        "title": "unique code for billing",
        "default": "",
        "type": "string"
      },
      "registered_office": {
        "title": "registed office location id",
        "default": "",
        "type": "string"
      }
    },
    "definitions": {
      "Contact": {
        "title": "Contact",
        "type": "object",
        "properties": {
          "id": {
            "title": "internal contact ID",
            "default": "",
            "type": "string"
          },
          "name": {
            "title": "Contact name",
            "default": "",
            "type": "string"
          },
          "email": {
            "title": "Contact email",
            "default": "",
            "type": "string"
          },
          "phone": {
            "title": "Contact phone",
            "default": "",
            "type": "string"
          },
          "holder": {
            "title": "Client holder",
            "default": false,
            "type": "boolean"
          }
        }
      }
    }
  },
  {
    "title": "CommonPrimary",
    "type": "object",
    "properties": {
      "header": {
        "title": "Header",
        "default": {
          "center": "v. centro",
          "nom": "v. strumento",
          "error": "errore",
          "uncertain": "U incertezza"
        },
        "type": "object"
      },
      "values": {
        "title": "primary values",
        "default": [],
        "type": "array",
        "items": {}
      },
      "uniformity": {
        "title": "primary uniformity",
        "default": 0,
        "type": "number"
      },
      "drift": {
        "title": "primary drift",
        "default": 0,
        "type": "number"
      },
      "a": {
        "title": "constant term",
        "default": 0,
        "type": "number"
      },
      "b": {
        "title": "first grade term",
        "default": 0,
        "type": "number"
      },
      "c": {
        "title": "second grade term",
        "default": 0,
        "type": "number"
      },
      "d": {
        "title": "third grade term",
        "default": 0,
        "type": "number"
      },
      "a_U": {
        "title": "constant term uncertainty",
        "default": 0,
        "type": "number"
      },
      "b_U": {
        "title": "first grade term uncertainty",
        "default": 0,
        "type": "number"
      }
    }
  },
  {
    "title": "CompleteCheck",
    "type": "object",
    "properties": {
      "lat": {
        "title": "LAT verification data complete",
        "default": false,
        "type": "boolean"
      },
      "leg": {
        "title": "LEG verification data complete",
        "default": false,
        "type": "boolean"
      },
      "iso": {
        "title": "scientific verification data complete",
        "default": false,
        "type": "boolean"
      },
      "iso_simple": {
        "title": "semplified scientific verification data complete",
        "default": false,
        "type": "boolean"
      }
    }
  },
  {
    "title": "Config",
    "type": "object",
    "properties": {
      "name": {
        "title": "Name",
        "type": "string"
      },
      "layout_type": {
        "title": "Layout Type",
        "type": "string"
      },
      "parameters": {
        "title": "Parameters",
        "default": [],
        "type": "array",
        "items": {}
      }
    },
    "required": [
      "name",
      "layout_type"
    ]
  },
  {
    "title": "Contact",
    "type": "object",
    "properties": {
      "id": {
        "title": "internal contact ID",
        "default": "",
        "type": "string"
      },
      "name": {
        "title": "Contact name",
        "default": "",
        "type": "string"
      },
      "email": {
        "title": "Contact email",
        "default": "",
        "type": "string"
      },
      "phone": {
        "title": "Contact phone",
        "default": "",
        "type": "string"
      },
      "holder": {
        "title": "Client holder",
        "default": false,
        "type": "boolean"
      }
    }
  },
  {
    "title": "Contaminant",
    "type": "object",
    "properties": {
      "header": {
        "title": "Header",
        "default": {
          "name": "tipo materiale",
          "dimension": "dimensione"
        },
        "type": "object"
      },
      "values": {
        "title": "Contaminant values",
        "default": [],
        "type": "array",
        "items": {}
      }
    }
  },
  {
    "title": "Department",
    "type": "object",
    "properties": {
      "id": {
        "title": "internal contact ID",
        "default": "",
        "type": "string"
      },
      "name": {
        "title": "department name",
        "default": "",
        "type": "string"
      },
      "desc": {
        "title": "department description",
        "default": "",
        "type": "string"
      },
      "contacts": {
        "title": "reference contact ids",
        "default": [],
        "type": "array",
        "items": {
          "type": "string"
        }
      }
    }
  },
  {
    "title": "Domain",
    "type": "object",
    "properties": {
      "_id": {
        "title": "Identifier",
        "type": "string"
      },
      "_rev": {
        "title": "Revision number",
        "type": "string"
      },
      "created": {
        "title": "Creation timestamp",
        "type": "integer"
      },
      "updated": {
        "title": "Update timestamp",
        "type": "integer"
      },
      "doc_type": {
        "title": "selector identifier for db",
        "default": "domain",
        "type": "string"
      },
      "created_by": {
        "title": "author user id",
        "default": "",
        "type": "string"
      },
      "updated_by": {
        "title": "doc modifier user id",
        "default": "",
        "type": "string"
      },
      "version": {
        "title": "Version",
        "default": 2,
        "type": "integer"
      },
      "dismissed": {
        "title": "Dismissed",
        "default": false,
        "type": "boolean"
      },
      "name": {
        "title": "Name",
        "type": "string"
      },
      "phone": {
        "title": "Phone",
        "type": "string"
      },
      "email": {
        "title": "Email",
        "type": "string"
      },
      "password": {
        "title": "Password",
        "type": "string"
      }
    },
    "required": [
      "name",
      "phone",
      "email",
      "password"
    ]
  },
  {
    "title": "EnvironmentCondition",
    "type": "object",
    "properties": {
      "temperature": {
        "title": "temperature data",
        "default": "",
        "type": "string"
      },
      "humidity": {
        "title": "Humidity level",
        "default": "",
        "type": "string"
      }
    }
  },
  {
    "title": "Formula",
    "type": "object",
    "properties": {
      "_id": {
        "title": "Identifier",
        "type": "string"
      },
      "_rev": {
        "title": "Revision number",
        "type": "string"
      },
      "created": {
        "title": "Creation timestamp",
        "type": "integer"
      },
      "updated": {
        "title": "Update timestamp",
        "type": "integer"
      },
      "doc_type": {
        "title": "selector identifier for db",
        "default": "formula",
        "type": "string"
      },
      "created_by": {
        "title": "author user id",
        "default": "",
        "type": "string"
      },
      "updated_by": {
        "title": "doc modifier user id",
        "default": "",
        "type": "string"
      },
      "version": {
        "title": "Version",
        "default": 2,
        "type": "integer"
      },
      "dismissed": {
        "title": "Dismissed",
        "default": false,
        "type": "boolean"
      },
      "equation": {
        "title": "equation to solve",
        "default": "",
        "type": "string"
      },
      "data": {
        "title": "paramters to use in the equation | array of values for the equation",
        "default": {},
        "type": "object"
      },
      "fixed_params": {
        "title": "if the parameter number is fixed or not (see stdev)",
        "default": false,
        "type": "boolean"
      },
      "notes": {
        "title": "notes or equation explanation",
        "default": "",
        "type": "string"
      }
    }
  },
  {
    "title": "GasTank",
    "type": "object",
    "properties": {
      "header": {
        "title": "Header",
        "default": {
          "g_type": "tipo di gas",
          "concentration": "concentrazione",
          "uom": [
            "%",
            "ppm"
          ],
          "precision": "accuratezza",
          "g_name": "nome del gas"
        },
        "type": "object"
      },
      "values": {
        "title": "Concentration values for gas tank",
        "default": [],
        "type": "array",
        "items": {}
      }
    }
  },
  {
    "title": "Hygrometer",
    "type": "object",
    "properties": {
      "header": {
        "title": "Header",
        "default": {
          "temp": "temperatura",
          "umidity": "umidit\u00e0",
          "un_hygro": "U sonda igrometrica",
          "un_thermocoup": "U sonda termocoppia"
        },
        "type": "object"
      },
      "values": {
        "title": "Hygrometer values",
        "default": [],
        "type": "array",
        "items": {}
      }
    }
  },
  {
    "title": "IdempiereSyncConfig",
    "type": "object",
    "properties": {
      "_id": {
        "title": "ID",
        "default": "config:idempiere_sync_data",
        "type": "string"
      },
      "_rev": {
        "title": "Revision number",
        "type": "string"
      },
      "created": {
        "title": "Creation timestamp",
        "type": "integer"
      },
      "updated": {
        "title": "Update timestamp",
        "type": "integer"
      },
      "doc_type": {
        "title": "Doc Type",
        "default": "config",
        "type": "string"
      },
      "created_by": {
        "title": "author user id",
        "default": "",
        "type": "string"
      },
      "updated_by": {
        "title": "doc modifier user id",
        "default": "",
        "type": "string"
      },
      "version": {
        "title": "doc version",
        "default": 1,
        "type": "integer"
      },
      "dismissed": {
        "title": "Dismissed",
        "default": false,
        "type": "boolean"
      },
      "status": {
        "title": "check if it's already syncing",
        "default": false,
        "type": "boolean"
      },
      "IE_time": {
        "title": "timestamp from idempiere, the last op updated",
        "default": 0,
        "type": "integer"
      },
      "last_run": {
        "title": "timestamp to check last time the function was run",
        "default": 0,
        "type": "integer"
      },
      "status_out": {
        "title": "check if it's already syncing",
        "default": false,
        "type": "boolean"
      },
      "IE_time_out": {
        "title": "timestamp from idempiere, the last op updated",
        "default": 0,
        "type": "integer"
      },
      "enable_sync": {
        "title": "to enable or disable sync",
        "default": false,
        "type": "boolean"
      }
    }
  },
  {
    "title": "ImagePoint",
    "type": "object",
    "properties": {
      "_id": {
        "title": "Identifier",
        "type": "string"
      },
      "_rev": {
        "title": "Revision number",
        "type": "string"
      },
      "created": {
        "title": "Creation timestamp",
        "type": "integer"
      },
      "updated": {
        "title": "Update timestamp",
        "type": "integer"
      },
      "doc_type": {
        "title": "selector identifier for db",
        "default": "imagepoint",
        "type": "string"
      },
      "created_by": {
        "title": "author user id",
        "default": "",
        "type": "string"
      },
      "updated_by": {
        "title": "doc modifier user id",
        "default": "",
        "type": "string"
      },
      "version": {
        "title": "Version",
        "default": 2,
        "type": "integer"
      },
      "dismissed": {
        "title": "Dismissed",
        "default": false,
        "type": "boolean"
      },
      "content_type": {
        "title": "content type of the image",
        "default": "",
        "type": "string"
      },
      "shape": {
        "title": "shape fo the image",
        "default": "",
        "type": "string"
      },
      "points": {
        "title": "points in the image",
        "default": "",
        "type": "string"
      }
    }
  },
  {
    "title": "InfraredSensor",
    "type": "object",
    "properties": {
      "header": {
        "title": "Header",
        "default": {
          "from": "da",
          "to": "a",
          "uncertain": "U incertezza"
        },
        "type": "object"
      },
      "values": {
        "title": "Infrared values",
        "default": [],
        "type": "array",
        "items": {}
      }
    }
  },
  {
    "title": "Instrument",
    "type": "object",
    "properties": {
      "external_id": {
        "title": "Idempiere key",
        "default": "",
        "type": "string"
      },
      "external_rev": {
        "title": "idempiere last revision",
        "type": "integer"
      },
      "updated_sync": {
        "title": "last sync time idempiere",
        "default": 0,
        "type": "integer"
      },
      "IE_time": {
        "title": "IE time MUST BE SAME AS UPDATED EACH IE",
        "type": "integer"
      },
      "ide_conflict": {
        "title": "if there is a conflict with idempiere",
        "default": false,
        "type": "boolean"
      },
      "_id": {
        "title": "Identifier",
        "type": "string"
      },
      "_rev": {
        "title": "Revision number",
        "type": "string"
      },
      "created": {
        "title": "Creation timestamp",
        "type": "integer"
      },
      "updated": {
        "title": "Update timestamp",
        "type": "integer"
      },
      "doc_type": {
        "title": "selector identifier for db",
        "default": "instrument",
        "type": "string"
      },
      "created_by": {
        "title": "author user id",
        "default": "",
        "type": "string"
      },
      "updated_by": {
        "title": "doc modifier user id",
        "default": "",
        "type": "string"
      },
      "version": {
        "title": "Version",
        "default": 2,
        "type": "integer"
      },
      "dismissed": {
        "title": "Dismissed",
        "default": false,
        "type": "boolean"
      },
      "manufacturer": {
        "title": "instrument manifacturer",
        "default": "",
        "type": "string"
      },
      "model": {
        "title": "instrument model",
        "default": "",
        "type": "string"
      },
      "serno": {
        "title": "instrument serial number",
        "default": "",
        "type": "string"
      },
      "standard_manufacturer": {
        "title": "standard idempiere manufacturer",
        "default": "",
        "type": "string"
      },
      "standard_model": {
        "title": "standard idempiere model",
        "default": "",
        "type": "string"
      },
      "client_id": {
        "title": "client id owner",
        "default": "",
        "type": "string"
      },
      "location_id": {
        "title": "instrument location id",
        "default": "",
        "type": "string"
      },
      "department_id": {
        "title": "instrument deparment id",
        "default": "",
        "type": "string"
      },
      "family": {
        "title": "instrument family",
        "default": "",
        "type": "string"
      },
      "platforms": {
        "title": "Platform list",
        "default": [],
        "type": "array",
        "items": {
          "$ref": "#/definitions/Platform"
        }
      },
      "metrological_info": {
        "title": "Department list",
        "default": {},
        "allOf": [
          {
            "$ref": "#/definitions/MetrologicalInfo"
          }
        ]
      },
      "optional_data": {
        "title": "Instrument optional data",
        "default": {},
        "type": "object"
      },
      "primary": {
        "title": "True => primary instrument",
        "default": false,
        "type": "boolean"
      },
      "primary_data": {
        "title": "primary data: certificate, data, expire, ...",
        "default": {},
        "allOf": [
          {
            "$ref": "#/definitions/PrimaryData"
          }
        ]
      },
      "domain": {
        "title": "User domain",
        "default": "",
        "type": "string"
      },
      "org_id": {
        "title": "owner of primary instrument",
        "default": "",
        "type": "string"
      },
      "used_by": {
        "title": "org the instrument is in use",
        "default": "",
        "type": "string"
      },
      "qr_code": {
        "title": "extra 2",
        "default": "",
        "type": "string"
      },
      "qr_code_crypted": {
        "title": "crypted qr",
        "default": "",
        "type": "string"
      },
      "name": {
        "title": "instrument name or client code",
        "default": "",
        "type": "string"
      },
      "description": {
        "title": "instrument description",
        "default": "",
        "type": "string"
      },
      "visible": {
        "title": "instrument removed flag",
        "default": true,
        "type": "boolean"
      },
      "complete": {
        "title": "complete check by op types",
        "default": {},
        "allOf": [
          {
            "$ref": "#/definitions/CompleteCheck"
          }
        ]
      },
      "ref_orgs": {
        "title": "org_id list that operated on their instrument",
        "default": [],
        "type": "array",
        "items": {
          "type": "string"
        }
      }
    },
    "definitions": {
      "Range": {
        "title": "Range",
        "type": "object",
        "properties": {
          "min": {
            "title": "Min capacity",
            "default": "0",
            "type": "string"
          },
          "max": {
            "title": "Max capacity",
            "default": "",
            "type": "string"
          },
          "e": {
            "title": "homologated resolution(e)",
            "default": "",
            "type": "string"
          },
          "d": {
            "title": "instrument resolution",
            "default": "",
            "type": "string"
          },
          "div_nr": {
            "title": "division number",
            "default": "",
            "type": "string"
          }
        }
      },
      "Tolerance": {
        "title": "Tolerance",
        "type": "object",
        "properties": {
          "t_type": {
            "title": "tolerance type manifacturer, user, law",
            "default": "",
            "type": "string"
          },
          "t_vals": {
            "title": "list of tolerances or unique",
            "default": [],
            "type": "array",
            "items": {}
          }
        }
      },
      "Platform": {
        "title": "Platform",
        "type": "object",
        "properties": {
          "id": {
            "title": "internal platform ID",
            "default": "",
            "type": "string"
          },
          "name": {
            "title": "platform name",
            "default": "",
            "type": "string"
          },
          "family": {
            "title": "Platform family",
            "default": "",
            "type": "string"
          },
          "uom": {
            "title": "platform unit of measure",
            "default": "",
            "type": "string"
          },
          "ranges": {
            "title": "Range list",
            "default": [
              {
                "min": "0",
                "max": "",
                "e": "",
                "d": "",
                "div_nr": ""
              }
            ],
            "type": "array",
            "items": {
              "$ref": "#/definitions/Range"
            }
          },
          "digits": {
            "title": "precision",
            "default": 0,
            "type": "integer"
          },
          "tolerance": {
            "title": "Tolerance list",
            "default": [],
            "type": "array",
            "items": {
              "$ref": "#/definitions/Tolerance"
            }
          },
          "instrument_class": {
            "title": "Instrument class",
            "default": 0,
            "type": "integer"
          },
          "category": {
            "title": "ID of the chosen category",
            "default": "",
            "type": "string"
          },
          "custom_data": {
            "title": "custom platform data",
            "default": {},
            "type": "object"
          }
        }
      },
      "MetroData": {
        "title": "MetroData",
        "type": "object",
        "properties": {
          "period": {
            "title": "Verification period months",
            "default": "12",
            "type": "string"
          },
          "last_report": {
            "title": "Last report code",
            "default": "",
            "type": "string"
          },
          "last_result": {
            "title": "last report result",
            "default": "",
            "type": "boolean"
          },
          "last_operation": {
            "title": "last operation timestamp",
            "default": 0,
            "type": "integer"
          },
          "next_operation": {
            "title": "next operation timestamp",
            "default": 0,
            "type": "integer"
          },
          "custom_data": {
            "title": "custom instrument legal data",
            "default": {},
            "type": "object"
          }
        }
      },
      "MetrologicalInfo": {
        "title": "MetrologicalInfo",
        "type": "object",
        "properties": {
          "lat": {
            "title": "LAT verification data",
            "default": {},
            "allOf": [
              {
                "$ref": "#/definitions/MetroData"
              }
            ]
          },
          "leg": {
            "title": "LEG verification data",
            "default": {},
            "allOf": [
              {
                "$ref": "#/definitions/MetroData"
              }
            ]
          },
          "iso": {
            "title": "ISO verification data",
            "default": {},
            "allOf": [
              {
                "$ref": "#/definitions/MetroData"
              }
            ]
          },
          "iso_simple": {
            "title": "semplified iso verification data",
            "default": {},
            "allOf": [
              {
                "$ref": "#/definitions/MetroData"
              }
            ]
          }
        }
      },
      "PrimaryData": {
        "title": "PrimaryData",
        "type": "object",
        "properties": {
          "certificate_nr": {
            "title": "certificate id",
            "type": "string"
          },
          "certificate_ref": {
            "title": "certificate file reference",
            "default": "",
            "type": "string"
          },
          "emission": {
            "title": "emission timestamp",
            "default": 0,
            "type": "integer"
          },
          "validity": {
            "title": "validity period - months",
            "default": "12",
            "type": "string"
          },
          "expire": {
            "title": "expire timestamp date",
            "default": 0,
            "type": "integer"
          },
          "certificate_authority": {
            "title": "certificate authority",
            "default": "",
            "type": "string"
          },
          "intermediate_certificate_nr": {
            "title": "certificate id",
            "type": "string"
          },
          "intermediate_certificate_ref": {
            "title": "certificate file reference",
            "default": "",
            "type": "string"
          },
          "intermediate_emission": {
            "title": "emission timestamp",
            "default": 0,
            "type": "integer"
          },
          "intermediate_validity": {
            "title": "validity period - months",
            "default": "12",
            "type": "string"
          },
          "intermediate_expire": {
            "title": "expire timestamp date",
            "default": 0,
            "type": "integer"
          },
          "intermediate_certificate_authority": {
            "title": "certificate authority",
            "default": "",
            "type": "string"
          },
          "data": {
            "title": "certificate data",
            "default": {},
            "type": "object"
          },
          "i_class": {
            "title": "primary instrument class",
            "default": "",
            "type": "string"
          },
          "complete": {
            "title": "if primary is complete",
            "default": true,
            "type": "boolean"
          },
          "uom": {
            "title": "primary uom use range",
            "default": "",
            "type": "string"
          },
          "min_use": {
            "title": "primary min use range",
            "default": "",
            "type": "string"
          },
          "max_use": {
            "title": "primary max use range",
            "default": "",
            "type": "string"
          },
          "active": {
            "title": "primary usable for trials",
            "default": true,
            "type": "boolean"
          }
        }
      },
      "CompleteCheck": {
        "title": "CompleteCheck",
        "type": "object",
        "properties": {
          "lat": {
            "title": "LAT verification data complete",
            "default": false,
            "type": "boolean"
          },
          "leg": {
            "title": "LEG verification data complete",
            "default": false,
            "type": "boolean"
          },
          "iso": {
            "title": "scientific verification data complete",
            "default": false,
            "type": "boolean"
          },
          "iso_simple": {
            "title": "semplified scientific verification data complete",
            "default": false,
            "type": "boolean"
          }
        }
      }
    }
  },
  {
    "title": "InstrumentHistory",
    "type": "object",
    "properties": {
      "_id": {
        "title": "Identifier",
        "type": "string"
      },
      "_rev": {
        "title": "Revision number",
        "type": "string"
      },
      "created": {
        "title": "Creation timestamp",
        "type": "integer"
      },
      "updated": {
        "title": "Update timestamp",
        "type": "integer"
      },
      "doc_type": {
        "title": "selector identifier for db",
        "default": "instrument_history",
        "type": "string"
      },
      "created_by": {
        "title": "author user id",
        "default": "",
        "type": "string"
      },
      "updated_by": {
        "title": "doc modifier user id",
        "default": "",
        "type": "string"
      },
      "version": {
        "title": "Version",
        "default": 2,
        "type": "integer"
      },
      "dismissed": {
        "title": "Dismissed",
        "default": false,
        "type": "boolean"
      },
      "revisions": {
        "title": "certificate dict containing list of primary instrument revisions",
        "default": {},
        "type": "object"
      }
    }
  },
  {
    "title": "IsoCustomData",
    "type": "object",
    "properties": {
      "environment": {
        "title": "environment conditions for ISO",
        "default": {
          "temperature": "",
          "humidity": ""
        },
        "allOf": [
          {
            "$ref": "#/definitions/EnvironmentCondition"
          }
        ]
      }
    },
    "definitions": {
      "EnvironmentCondition": {
        "title": "EnvironmentCondition",
        "type": "object",
        "properties": {
          "temperature": {
            "title": "temperature data",
            "default": "",
            "type": "string"
          },
          "humidity": {
            "title": "Humidity level",
            "default": "",
            "type": "string"
          }
        }
      }
    }
  },
  {
    "title": "LatCustomData",
    "type": "object",
    "properties": {
      "local_stability": {
        "title": "Local stability",
        "default": "",
        "type": "string"
      },
      "room_description": {
        "title": "room where instrument is installed",
        "default": "",
        "type": "string"
      }
    }
  },
  {
    "title": "LegCustomData",
    "type": "object",
    "properties": {
      "cause": {
        "title": "Cause of intervention",
        "default": "expire",
        "type": "string"
      },
      "repairer": {
        "title": "repairer name",
        "default": "",
        "type": "string"
      },
      "other": {
        "title": "other description",
        "default": "",
        "type": "string"
      }
    }
  },
  {
    "title": "LegalAwiMetroData",
    "type": "object",
    "properties": {
      "conform_module": {
        "title": "modulo accertamento conformit\u00e0",
        "default": "",
        "type": "string"
      },
      "cert_number": {
        "title": "certification number",
        "default": "",
        "type": "string"
      },
      "org_notified": {
        "title": "certification organization",
        "default": "",
        "type": "string"
      },
      "CE_year": {
        "title": "CE marking year",
        "default": "",
        "type": "string"
      },
      "commissioning_date": {
        "title": "commissioning date",
        "default": 0,
        "type": "integer"
      },
      "electronic_seal": {
        "title": "electronic seal",
        "default": false,
        "type": "boolean"
      },
      "metro_national": {
        "title": "national certification",
        "default": false,
        "type": "boolean"
      },
      "year_production": {
        "title": "production year",
        "default": "",
        "type": "string"
      },
      "decree_adminssion": {
        "title": "Decreto ammissione verifica",
        "default": "",
        "type": "string"
      },
      "metric_office": {
        "title": "ufficio metrico/ispettore",
        "default": "",
        "type": "string"
      },
      "year_marking": {
        "title": "anno marcatura",
        "default": "",
        "type": "string"
      },
      "year_commissioning": {
        "title": "anno messa in servizio",
        "default": 0,
        "type": "integer"
      }
    }
  },
  {
    "title": "LegalNawiEleMetroData",
    "type": "object",
    "properties": {
      "conform_module": {
        "title": "modulo accertamento conformit\u00e0",
        "default": "",
        "type": "string"
      },
      "cert_number": {
        "title": "certification number",
        "default": "",
        "type": "string"
      },
      "org_notified": {
        "title": "certification organization",
        "default": "",
        "type": "string"
      },
      "CE_year": {
        "title": "CE marking year",
        "default": "",
        "type": "string"
      },
      "commissioning_date": {
        "title": "commissioning date",
        "default": 0,
        "type": "integer"
      },
      "electronic_seal": {
        "title": "electronic seal",
        "default": false,
        "type": "boolean"
      },
      "metro_national": {
        "title": "national certification",
        "default": false,
        "type": "boolean"
      },
      "year_production": {
        "title": "production year",
        "default": "",
        "type": "string"
      },
      "decree_adminssion": {
        "title": "Decreto ammissione verifica",
        "default": "",
        "type": "string"
      },
      "metric_office": {
        "title": "ufficio metrico/ispettore",
        "default": "",
        "type": "string"
      },
      "year_marking": {
        "title": "anno marcatura",
        "default": "",
        "type": "string"
      },
      "year_commissioning": {
        "title": "anno messa in servizio",
        "default": 0,
        "type": "integer"
      }
    }
  },
  {
    "title": "LegalNawiMechMetroData",
    "type": "object",
    "properties": {
      "conform_module": {
        "title": "modulo accertamento conformit\u00e0",
        "default": "",
        "type": "string"
      },
      "cert_number": {
        "title": "certification number",
        "default": "",
        "type": "string"
      },
      "org_notified": {
        "title": "certification organization",
        "default": "",
        "type": "string"
      },
      "CE_year": {
        "title": "CE marking year",
        "default": "",
        "type": "string"
      },
      "commissioning_date": {
        "title": "commissioning date",
        "default": 0,
        "type": "integer"
      },
      "electronic_seal": {
        "title": "electronic seal",
        "default": false,
        "type": "boolean"
      },
      "metro_national": {
        "title": "national certification",
        "default": false,
        "type": "boolean"
      },
      "year_production": {
        "title": "production year",
        "default": "",
        "type": "string"
      },
      "decree_adminssion": {
        "title": "Decreto ammissione verifica",
        "default": "",
        "type": "string"
      },
      "metric_office": {
        "title": "ufficio metrico/ispettore",
        "default": "",
        "type": "string"
      },
      "year_marking": {
        "title": "anno marcatura",
        "default": "",
        "type": "string"
      },
      "year_commissioning": {
        "title": "anno messa in servizio",
        "default": 0,
        "type": "integer"
      }
    }
  },
  {
    "title": "Location",
    "type": "object",
    "properties": {
      "external_id": {
        "title": "external key used by instruments",
        "type": "string"
      },
      "external_rev": {
        "title": "idempiere last revision",
        "type": "integer"
      },
      "updated_sync": {
        "title": "last sync time idempiere",
        "default": 0,
        "type": "integer"
      },
      "IE_time": {
        "title": "IE time MUST BE SAME AS UPDATED EACH IE",
        "type": "integer"
      },
      "ide_conflict": {
        "title": "if there is a conflict with idempiere",
        "default": false,
        "type": "boolean"
      },
      "_id": {
        "title": "Identifier",
        "type": "string"
      },
      "_rev": {
        "title": "Revision number",
        "type": "string"
      },
      "created": {
        "title": "Creation timestamp",
        "type": "integer"
      },
      "updated": {
        "title": "Update timestamp",
        "type": "integer"
      },
      "doc_type": {
        "title": "selector identifier for db",
        "default": "location",
        "type": "string"
      },
      "created_by": {
        "title": "author user id",
        "default": "",
        "type": "string"
      },
      "updated_by": {
        "title": "doc modifier user id",
        "default": "",
        "type": "string"
      },
      "version": {
        "title": "Version",
        "default": 2,
        "type": "integer"
      },
      "dismissed": {
        "title": "Dismissed",
        "default": false,
        "type": "boolean"
      },
      "name": {
        "title": "location name",
        "default": "",
        "type": "string"
      },
      "client_id": {
        "title": "client identifier",
        "type": "string"
      },
      "address": {
        "title": "address street",
        "default": "",
        "type": "string"
      },
      "addrNum": {
        "title": "address number",
        "default": "",
        "type": "string"
      },
      "city": {
        "title": "city name",
        "default": "",
        "type": "string"
      },
      "zip": {
        "title": "zip code",
        "type": "string"
      },
      "district": {
        "title": "district",
        "default": "",
        "type": "string"
      },
      "country": {
        "title": "country",
        "default": "Italia",
        "type": "string"
      },
      "complete": {
        "title": "complete flag",
        "default": false,
        "type": "boolean"
      },
      "contacts": {
        "title": "reference contact ids",
        "default": [],
        "type": "array",
        "items": {
          "type": "string"
        }
      },
      "departments": {
        "title": "department dict",
        "default": {},
        "type": "object",
        "additionalProperties": {
          "$ref": "#/definitions/Department"
        }
      },
      "domain": {
        "title": "User domain",
        "type": "string"
      },
      "ref_orgs": {
        "title": "org_id list that operated on their instrument",
        "default": [],
        "type": "array",
        "items": {
          "type": "string"
        }
      }
    },
    "definitions": {
      "Department": {
        "title": "Department",
        "type": "object",
        "properties": {
          "id": {
            "title": "internal contact ID",
            "default": "",
            "type": "string"
          },
          "name": {
            "title": "department name",
            "default": "",
            "type": "string"
          },
          "desc": {
            "title": "department description",
            "default": "",
            "type": "string"
          },
          "contacts": {
            "title": "reference contact ids",
            "default": [],
            "type": "array",
            "items": {
              "type": "string"
            }
          }
        }
      }
    }
  },
  {
    "title": "LogoConfig",
    "type": "object",
    "properties": {
      "_id": {
        "title": "Identifier",
        "default": "config:logo_data",
        "type": "string"
      },
      "_rev": {
        "title": "Revision number",
        "type": "string"
      },
      "created": {
        "title": "Creation timestamp",
        "type": "integer"
      },
      "updated": {
        "title": "Update timestamp",
        "type": "integer"
      },
      "doc_type": {
        "title": "Doc Type",
        "default": "config",
        "type": "string"
      },
      "created_by": {
        "title": "author user id",
        "default": "",
        "type": "string"
      },
      "updated_by": {
        "title": "doc modifier user id",
        "default": "",
        "type": "string"
      },
      "version": {
        "title": "logo version",
        "default": 1,
        "type": "integer"
      },
      "dismissed": {
        "title": "Dismissed",
        "default": false,
        "type": "boolean"
      }
    }
  },
  {
    "title": "Manufacturer",
    "type": "object",
    "properties": {
      "external_id": {
        "title": "Idempiere key",
        "default": "",
        "type": "string"
      },
      "external_rev": {
        "title": "idempiere last revision",
        "type": "integer"
      },
      "updated_sync": {
        "title": "last sync time idempiere",
        "default": 0,
        "type": "integer"
      },
      "IE_time": {
        "title": "IE time MUST BE SAME AS UPDATED EACH IE",
        "type": "integer"
      },
      "ide_conflict": {
        "title": "if there is a conflict with idempiere",
        "default": false,
        "type": "boolean"
      },
      "_id": {
        "title": "Identifier",
        "type": "string"
      },
      "_rev": {
        "title": "Revision number",
        "type": "string"
      },
      "created": {
        "title": "Creation timestamp",
        "type": "integer"
      },
      "updated": {
        "title": "Update timestamp",
        "type": "integer"
      },
      "doc_type": {
        "title": "Doc Type",
        "default": "manufacturer",
        "type": "string"
      },
      "created_by": {
        "title": "author user id",
        "default": "",
        "type": "string"
      },
      "updated_by": {
        "title": "doc modifier user id",
        "default": "",
        "type": "string"
      },
      "version": {
        "title": "Version",
        "default": 2,
        "type": "integer"
      },
      "dismissed": {
        "title": "Dismissed",
        "default": false,
        "type": "boolean"
      },
      "name": {
        "title": "Name",
        "type": "string"
      },
      "models": {
        "title": "Models",
        "default": [],
        "type": "array",
        "items": {
          "$ref": "#/definitions/Model"
        }
      }
    },
    "definitions": {
      "Model": {
        "title": "Model",
        "type": "object",
        "properties": {
          "name": {
            "title": "Name",
            "type": "string"
          },
          "doc_type": {
            "title": "Doc Type",
            "default": "model",
            "type": "string"
          },
          "external_id": {
            "title": "External Id",
            "type": "string"
          }
        }
      }
    }
  },
  {
    "title": "Master",
    "type": "object",
    "properties": {
      "_id": {
        "title": "Identifier",
        "type": "string"
      },
      "_rev": {
        "title": "Revision number",
        "type": "string"
      },
      "created": {
        "title": "Creation timestamp",
        "type": "integer"
      },
      "updated": {
        "title": "Update timestamp",
        "type": "integer"
      },
      "doc_type": {
        "title": "Doc Type",
        "default": "master",
        "type": "string"
      },
      "created_by": {
        "title": "author user id",
        "default": "",
        "type": "string"
      },
      "updated_by": {
        "title": "doc modifier user id",
        "default": "",
        "type": "string"
      },
      "version": {
        "title": "Version",
        "default": 2,
        "type": "integer"
      },
      "dismissed": {
        "title": "Dismissed",
        "default": false,
        "type": "boolean"
      },
      "master_rev": {
        "title": "master revision",
        "default": "",
        "type": "string"
      },
      "master_module": {
        "title": "master module for report",
        "default": "",
        "type": "string"
      },
      "master_mod_cert": {
        "title": "master module for certificate",
        "default": "",
        "type": "string"
      },
      "isos_laws": {
        "title": "laws for iso simple",
        "default": "",
        "type": "string"
      },
      "isos_techN": {
        "title": "tech norms for iso simple",
        "default": "",
        "type": "string"
      },
      "name": {
        "title": "master name",
        "default": "",
        "type": "string"
      },
      "family": {
        "title": "master instrument family",
        "default": "",
        "type": "string"
      },
      "op_type": {
        "title": "master type of operation",
        "default": "",
        "type": "string"
      },
      "blocks": {
        "title": "master Block list",
        "default": [],
        "type": "array",
        "items": {}
      },
      "primary_ids": {
        "title": "list of primary ids, used for report",
        "default": [],
        "type": "array",
        "items": {}
      },
      "has_pretest": {
        "title": "if there is pretest in blocks",
        "default": false,
        "type": "boolean"
      },
      "static": {
        "title": "dynamic measurements or not",
        "default": true,
        "type": "boolean"
      },
      "maintenance": {
        "title": "maintenance block present",
        "default": false,
        "type": "boolean"
      },
      "complete": {
        "title": "master complete flag",
        "default": false,
        "type": "boolean"
      },
      "active": {
        "title": "Master active flag",
        "default": false,
        "type": "boolean"
      },
      "owner": {
        "title": "master author id",
        "default": "",
        "type": "string"
      },
      "selected_mode": {
        "title": "service or installation",
        "default": "service",
        "type": "string"
      },
      "assigned_procedure": {
        "title": "ID of the assigned procedure",
        "default": "",
        "type": "string"
      }
    }
  },
  {
    "title": "MetroData",
    "type": "object",
    "properties": {
      "period": {
        "title": "Verification period months",
        "default": "12",
        "type": "string"
      },
      "last_report": {
        "title": "Last report code",
        "default": "",
        "type": "string"
      },
      "last_result": {
        "title": "last report result",
        "default": "",
        "type": "boolean"
      },
      "last_operation": {
        "title": "last operation timestamp",
        "default": 0,
        "type": "integer"
      },
      "next_operation": {
        "title": "next operation timestamp",
        "default": 0,
        "type": "integer"
      },
      "custom_data": {
        "title": "custom instrument legal data",
        "default": {},
        "type": "object"
      }
    }
  },
  {
    "title": "MetrologicalInfo",
    "type": "object",
    "properties": {
      "lat": {
        "title": "LAT verification data",
        "default": {},
        "allOf": [
          {
            "$ref": "#/definitions/MetroData"
          }
        ]
      },
      "leg": {
        "title": "LEG verification data",
        "default": {},
        "allOf": [
          {
            "$ref": "#/definitions/MetroData"
          }
        ]
      },
      "iso": {
        "title": "ISO verification data",
        "default": {},
        "allOf": [
          {
            "$ref": "#/definitions/MetroData"
          }
        ]
      },
      "iso_simple": {
        "title": "semplified iso verification data",
        "default": {},
        "allOf": [
          {
            "$ref": "#/definitions/MetroData"
          }
        ]
      }
    },
    "definitions": {
      "MetroData": {
        "title": "MetroData",
        "type": "object",
        "properties": {
          "period": {
            "title": "Verification period months",
            "default": "12",
            "type": "string"
          },
          "last_report": {
            "title": "Last report code",
            "default": "",
            "type": "string"
          },
          "last_result": {
            "title": "last report result",
            "default": "",
            "type": "boolean"
          },
          "last_operation": {
            "title": "last operation timestamp",
            "default": 0,
            "type": "integer"
          },
          "next_operation": {
            "title": "next operation timestamp",
            "default": 0,
            "type": "integer"
          },
          "custom_data": {
            "title": "custom instrument legal data",
            "default": {},
            "type": "object"
          }
        }
      }
    }
  },
  {
    "title": "Micrometer",
    "type": "object",
    "properties": {
      "header": {
        "title": "Header",
        "default": {},
        "type": "object"
      },
      "values": {
        "title": "Micrometer values",
        "default": [],
        "type": "array",
        "items": {}
      }
    }
  },
  {
    "title": "Microscope",
    "type": "object",
    "properties": {
      "header": {
        "title": "Header",
        "default": {},
        "type": "object"
      },
      "values": {
        "title": "Microscope values",
        "default": [],
        "type": "array",
        "items": {}
      }
    }
  },
  {
    "title": "MicroscopeSlide",
    "type": "object",
    "properties": {
      "header": {
        "title": "Header",
        "default": {},
        "type": "object"
      },
      "values": {
        "title": "Microscope slide values",
        "default": [],
        "type": "array",
        "items": {}
      }
    }
  },
  {
    "title": "Model",
    "type": "object",
    "properties": {
      "name": {
        "title": "Name",
        "type": "string"
      },
      "doc_type": {
        "title": "Doc Type",
        "default": "model",
        "type": "string"
      },
      "external_id": {
        "title": "External Id",
        "type": "string"
      }
    }
  },
  {
    "title": "MyBaseModel",
    "type": "object",
    "properties": {
      "_id": {
        "title": "Identifier",
        "type": "string"
      },
      "_rev": {
        "title": "Revision number",
        "type": "string"
      },
      "created": {
        "title": "Creation timestamp",
        "type": "integer"
      },
      "updated": {
        "title": "Update timestamp",
        "type": "integer"
      },
      "doc_type": {
        "title": "Document type",
        "default": "",
        "type": "string"
      },
      "created_by": {
        "title": "author user id",
        "default": "",
        "type": "string"
      },
      "updated_by": {
        "title": "doc modifier user id",
        "default": "",
        "type": "string"
      },
      "version": {
        "title": "doc version",
        "default": 1,
        "type": "integer"
      },
      "dismissed": {
        "title": "Dismissed",
        "default": false,
        "type": "boolean"
      }
    }
  },
  {
    "title": "MyExportable",
    "type": "object",
    "properties": {
      "external_id": {
        "title": "Idempiere key",
        "default": "",
        "type": "string"
      },
      "external_rev": {
        "title": "idempiere last revision",
        "type": "integer"
      },
      "updated_sync": {
        "title": "last sync time idempiere",
        "default": 0,
        "type": "integer"
      },
      "IE_time": {
        "title": "IE time MUST BE SAME AS UPDATED EACH IE",
        "type": "integer"
      },
      "ide_conflict": {
        "title": "if there is a conflict with idempiere",
        "default": false,
        "type": "boolean"
      }
    }
  },
  {
    "title": "MyImportable",
    "type": "object",
    "properties": {
      "id": {
        "title": "Id",
        "type": "string"
      },
      "type": {
        "title": "Type",
        "type": "string"
      }
    },
    "required": [
      "id",
      "type"
    ]
  },
  {
    "title": "MyToken",
    "type": "object",
    "properties": {
      "_id": {
        "title": "Identifier",
        "type": "string"
      },
      "_rev": {
        "title": "Revision number",
        "type": "string"
      },
      "created": {
        "title": "Creation timestamp",
        "type": "integer"
      },
      "updated": {
        "title": "Update timestamp",
        "type": "integer"
      },
      "doc_type": {
        "title": "Doc Type",
        "default": "token",
        "type": "string"
      },
      "created_by": {
        "title": "author user id",
        "default": "",
        "type": "string"
      },
      "updated_by": {
        "title": "doc modifier user id",
        "default": "",
        "type": "string"
      },
      "version": {
        "title": "doc version",
        "default": 1,
        "type": "integer"
      },
      "dismissed": {
        "title": "Dismissed",
        "default": false,
        "type": "boolean"
      },
      "user_id": {
        "title": "User Id",
        "type": "string"
      },
      "token": {
        "title": "Token",
        "type": "string"
      },
      "banned": {
        "title": "Banned",
        "default": false,
        "type": "boolean"
      }
    }
  },
  {
    "title": "OpCheck",
    "type": "object",
    "properties": {
      "order": {
        "title": "order number",
        "default": false,
        "type": "boolean"
      },
      "client": {
        "title": "client complete check",
        "default": false,
        "type": "boolean"
      },
      "location": {
        "title": "location complete check",
        "default": false,
        "type": "boolean"
      }
    }
  },
  {
    "title": "OpType",
    "type": "object",
    "properties": {
      "instrument_ids": {
        "title": "Instrument Ids",
        "default": [],
        "type": "array",
        "items": {}
      },
      "all_instrument": {
        "title": "All Instrument",
        "default": false,
        "type": "boolean"
      },
      "instr_checks": {
        "title": "Instr Checks",
        "default": {},
        "type": "object"
      }
    }
  },
  {
    "title": "Operation",
    "type": "object",
    "properties": {
      "external_id": {
        "title": "external key used by instruments",
        "default": "",
        "type": "string"
      },
      "external_rev": {
        "title": "idempiere last revision",
        "type": "integer"
      },
      "updated_sync": {
        "title": "last sync time idempiere",
        "default": 0,
        "type": "integer"
      },
      "IE_time": {
        "title": "IE time MUST BE SAME AS UPDATED EACH IE",
        "type": "integer"
      },
      "ide_conflict": {
        "title": "if there is a conflict with idempiere",
        "default": false,
        "type": "boolean"
      },
      "_id": {
        "title": "Identifier",
        "type": "string"
      },
      "_rev": {
        "title": "Revision number",
        "type": "string"
      },
      "created": {
        "title": "Creation timestamp",
        "type": "integer"
      },
      "updated": {
        "title": "Update timestamp",
        "type": "integer"
      },
      "doc_type": {
        "title": "Doc Type",
        "default": "operation",
        "type": "string"
      },
      "created_by": {
        "title": "author user id",
        "default": "",
        "type": "string"
      },
      "updated_by": {
        "title": "doc modifier user id",
        "default": "",
        "type": "string"
      },
      "version": {
        "title": "Version",
        "default": 2,
        "type": "integer"
      },
      "dismissed": {
        "title": "Dismissed",
        "default": false,
        "type": "boolean"
      },
      "name": {
        "title": "Operation name (optional)",
        "default": "",
        "type": "string"
      },
      "note": {
        "title": "Operation note (optional)",
        "default": "",
        "type": "string"
      },
      "client_id": {
        "title": "client id",
        "default": "",
        "type": "string"
      },
      "partner_id": {
        "title": "bussines partner id",
        "default": "",
        "type": "string"
      },
      "all_instrument": {
        "title": "all instrument flags",
        "default": false,
        "type": "boolean"
      },
      "instrument_ids": {
        "title": "instrument id",
        "default": [],
        "type": "array",
        "items": {}
      },
      "comparator_ids": {
        "title": "comparator id",
        "default": [],
        "type": "array",
        "items": {}
      },
      "location_id": {
        "title": "location id",
        "default": "",
        "type": "string"
      },
      "department_ids": {
        "title": "department ids",
        "default": [],
        "type": "array",
        "items": {}
      },
      "owner": {
        "title": "owner id",
        "default": "",
        "type": "string"
      },
      "org_id": {
        "title": "organization id",
        "default": "",
        "type": "string"
      },
      "status": {
        "title": "new | working | canceled | closed",
        "default": "created",
        "type": "string"
      },
      "op_type": {
        "title": "operation type - all instruments operation",
        "default": "",
        "type": "string"
      },
      "tags": {
        "title": "Tags",
        "default": [],
        "type": "array",
        "items": {}
      },
      "assigned": {
        "title": "user ids assigned",
        "default": [],
        "type": "array",
        "items": {}
      },
      "op_date": {
        "title": "operation timestamp ",
        "default": 0,
        "type": "integer"
      },
      "order_nr": {
        "title": "order number",
        "default": "",
        "type": "string"
      },
      "order_date": {
        "title": "order timestamp",
        "default": 0,
        "type": "integer"
      },
      "check": {
        "title": "operation check",
        "allOf": [
          {
            "$ref": "#/definitions/OpCheck"
          }
        ]
      },
      "contacts": {
        "title": "contact to be used for email reports",
        "default": [],
        "type": "array",
        "items": {}
      },
      "lock": {
        "title": "operation locked by system",
        "default": false,
        "type": "boolean"
      },
      "sync": {
        "title": "remote operations db sync flag",
        "default": true,
        "type": "boolean"
      }
    },
    "definitions": {
      "OpCheck": {
        "title": "OpCheck",
        "type": "object",
        "properties": {
          "order": {
            "title": "order number",
            "default": false,
            "type": "boolean"
          },
          "client": {
            "title": "client complete check",
            "default": false,
            "type": "boolean"
          },
          "location": {
            "title": "location complete check",
            "default": false,
            "type": "boolean"
          }
        }
      }
    }
  },
  {
    "title": "Organism",
    "type": "object",
    "properties": {
      "external_id": {
        "title": "Idempiere key",
        "default": "",
        "type": "string"
      },
      "external_rev": {
        "title": "idempiere last revision",
        "type": "integer"
      },
      "updated_sync": {
        "title": "last sync time idempiere",
        "default": 0,
        "type": "integer"
      },
      "IE_time": {
        "title": "IE time MUST BE SAME AS UPDATED EACH IE",
        "type": "integer"
      },
      "ide_conflict": {
        "title": "if there is a conflict with idempiere",
        "default": false,
        "type": "boolean"
      },
      "_id": {
        "title": "Identifier",
        "type": "string"
      },
      "_rev": {
        "title": "Revision number",
        "type": "string"
      },
      "created": {
        "title": "Creation timestamp",
        "type": "integer"
      },
      "updated": {
        "title": "Update timestamp",
        "type": "integer"
      },
      "doc_type": {
        "title": "selector identifier for db",
        "default": "organism",
        "type": "string"
      },
      "created_by": {
        "title": "author user id",
        "default": "",
        "type": "string"
      },
      "updated_by": {
        "title": "doc modifier user id",
        "default": "",
        "type": "string"
      },
      "version": {
        "title": "Version",
        "default": 2,
        "type": "integer"
      },
      "dismissed": {
        "title": "Dismissed",
        "default": false,
        "type": "boolean"
      },
      "name": {
        "title": "organization name",
        "type": "string"
      },
      "piva": {
        "title": "organization VAT",
        "type": "string"
      },
      "fiscal_code": {
        "title": "fiscal code of the owner",
        "type": "string"
      },
      "pec": {
        "title": "pec of the organism",
        "default": "",
        "type": "string"
      },
      "website": {
        "title": "site of the organism",
        "default": "",
        "type": "string"
      },
      "phone_organism": {
        "title": "phone of the organism",
        "default": "",
        "type": "string"
      },
      "fax_organism": {
        "title": "fax of the organism",
        "default": "",
        "type": "string"
      },
      "contact_name": {
        "title": "contact name",
        "default": "",
        "type": "string"
      },
      "contact_email": {
        "title": "contact email",
        "default": "",
        "type": "string"
      },
      "contact_phone": {
        "title": "contact phone",
        "default": "",
        "type": "string"
      },
      "address": {
        "title": "address street",
        "default": "",
        "type": "string"
      },
      "addrNum": {
        "title": "address number",
        "default": "",
        "type": "string"
      },
      "city": {
        "title": "city name",
        "default": "",
        "type": "string"
      },
      "zip": {
        "title": "zip code",
        "type": "string"
      },
      "district": {
        "title": "district",
        "default": "",
        "type": "string"
      },
      "country": {
        "title": "country",
        "default": "Italia",
        "type": "string"
      },
      "file_ref": {
        "title": "logo ref url",
        "default": "",
        "type": "string"
      },
      "file_name": {
        "title": "logo name file",
        "default": "",
        "type": "string"
      },
      "emission_enabled": {
        "title": "certificates emission flag",
        "default": false,
        "type": "boolean"
      }
    }
  },
  {
    "title": "Platform",
    "type": "object",
    "properties": {
      "id": {
        "title": "internal platform ID",
        "default": "",
        "type": "string"
      },
      "name": {
        "title": "platform name",
        "default": "",
        "type": "string"
      },
      "family": {
        "title": "Platform family",
        "default": "",
        "type": "string"
      },
      "uom": {
        "title": "platform unit of measure",
        "default": "",
        "type": "string"
      },
      "ranges": {
        "title": "Range list",
        "default": [
          {
            "min": "0",
            "max": "",
            "e": "",
            "d": "",
            "div_nr": ""
          }
        ],
        "type": "array",
        "items": {
          "$ref": "#/definitions/Range"
        }
      },
      "digits": {
        "title": "precision",
        "default": 0,
        "type": "integer"
      },
      "tolerance": {
        "title": "Tolerance list",
        "default": [],
        "type": "array",
        "items": {
          "$ref": "#/definitions/Tolerance"
        }
      },
      "instrument_class": {
        "title": "Instrument class",
        "default": 0,
        "type": "integer"
      },
      "category": {
        "title": "ID of the chosen category",
        "default": "",
        "type": "string"
      },
      "custom_data": {
        "title": "custom platform data",
        "default": {},
        "type": "object"
      }
    },
    "definitions": {
      "Range": {
        "title": "Range",
        "type": "object",
        "properties": {
          "min": {
            "title": "Min capacity",
            "default": "0",
            "type": "string"
          },
          "max": {
            "title": "Max capacity",
            "default": "",
            "type": "string"
          },
          "e": {
            "title": "homologated resolution(e)",
            "default": "",
            "type": "string"
          },
          "d": {
            "title": "instrument resolution",
            "default": "",
            "type": "string"
          },
          "div_nr": {
            "title": "division number",
            "default": "",
            "type": "string"
          }
        }
      },
      "Tolerance": {
        "title": "Tolerance",
        "type": "object",
        "properties": {
          "t_type": {
            "title": "tolerance type manifacturer, user, law",
            "default": "",
            "type": "string"
          },
          "t_vals": {
            "title": "list of tolerances or unique",
            "default": [],
            "type": "array",
            "items": {}
          }
        }
      }
    }
  },
  {
    "title": "PlatformCustomAwiScales",
    "type": "object",
    "properties": {
      "power_supply": {
        "title": "power supply",
        "default": "",
        "type": "string"
      },
      "frequency": {
        "title": "power supply frequnecy",
        "default": "",
        "type": "string"
      },
      "temperature_range": {
        "title": "temperature range",
        "default": "",
        "type": "string"
      },
      "fluid_pressure": {
        "title": "fluid pressure",
        "default": "",
        "type": "string"
      },
      "speed_type": {
        "title": "speed type variation",
        "default": "",
        "type": "string"
      },
      "min_speed": {
        "title": "min speed",
        "default": "",
        "type": "string"
      },
      "max_speed": {
        "title": "max speed",
        "default": "",
        "type": "string"
      },
      "add_tare": {
        "title": "add tare",
        "default": "",
        "type": "string"
      },
      "sub_tare": {
        "title": "sub tare",
        "default": "",
        "type": "string"
      },
      "support_points": {
        "title": "Support points",
        "default": "4",
        "type": "string"
      }
    }
  },
  {
    "title": "PlatformCustomDataDoser",
    "type": "object",
    "properties": {
      "specific_weight": {
        "title": "specific weight of liquid",
        "default": "",
        "type": "string"
      }
    }
  },
  {
    "title": "PlatformCustomNawiMechScales",
    "type": "object",
    "properties": {
      "support_points": {
        "title": "Support points",
        "default": "",
        "type": "string"
      },
      "horinz_check": {
        "title": "Horizontal check presence",
        "default": false,
        "type": "boolean"
      },
      "shape": {
        "title": "shape scales plate",
        "default": "",
        "type": "string"
      },
      "multiext": {
        "title": "multiextension scales",
        "default": false,
        "type": "boolean"
      },
      "bool": {
        "title": "multiextension scales",
        "default": false,
        "type": "boolean"
      }
    }
  },
  {
    "title": "PlatformCustomNawiScales",
    "type": "object",
    "properties": {
      "support_points": {
        "title": "Support points",
        "default": "4",
        "type": "string"
      },
      "horinz_check": {
        "title": "Horizontal check presence",
        "default": false,
        "type": "boolean"
      },
      "calibration_type": {
        "title": "Calibration type interna|esterna|N/A",
        "default": "",
        "type": "string"
      },
      "shape": {
        "title": "shape scales plate",
        "default": "",
        "type": "string"
      },
      "multiext": {
        "title": "multiextension scales",
        "default": false,
        "type": "boolean"
      },
      "bool": {
        "title": "multiextension scales",
        "default": false,
        "type": "boolean"
      }
    }
  },
  {
    "title": "PressureGauge",
    "type": "object",
    "properties": {
      "header": {
        "title": "Header",
        "default": {
          "center": "v. centro",
          "nom": "v. strumento crescente",
          "nom_down": "v. strumento decrescente",
          "error": "errore crescente",
          "error_down": "errore decrescente",
          "uncertain": "U incertezza crescente",
          "uncertain_down": "U incertezza decrescente"
        },
        "type": "object"
      },
      "values": {
        "title": "primary values",
        "default": [],
        "type": "array",
        "items": {}
      },
      "uniformity": {
        "title": "primary uniformity",
        "default": "",
        "type": "number"
      },
      "drift": {
        "title": "primary drift",
        "default": "",
        "type": "number"
      },
      "a": {
        "title": "constant",
        "default": "0",
        "type": "number"
      },
      "b": {
        "title": "first grade term",
        "default": "0",
        "type": "number"
      },
      "c": {
        "title": "second grade term",
        "default": "0",
        "type": "number"
      },
      "d": {
        "title": "third grade term",
        "default": "0",
        "type": "number"
      },
      "a_U": {
        "title": "constant term uncertainty ",
        "default": "0",
        "type": "number"
      },
      "b_U": {
        "title": "first grade term uncertainty",
        "default": "0",
        "type": "number"
      },
      "b_down": {
        "title": "first grade term decreasing",
        "default": "0",
        "type": "number"
      },
      "c_down": {
        "title": "second grade term decreasing",
        "default": "0",
        "type": "number"
      },
      "d_down": {
        "title": "third grade term decreasing",
        "default": "0",
        "type": "number"
      },
      "a_U_down": {
        "title": "constant term uncertainty decreasing",
        "default": "0",
        "type": "number"
      },
      "b_U_down": {
        "title": "first grade term uncertainty decreasing",
        "default": "0",
        "type": "number"
      }
    }
  },
  {
    "title": "PrimaryData",
    "type": "object",
    "properties": {
      "certificate_nr": {
        "title": "certificate id",
        "type": "string"
      },
      "certificate_ref": {
        "title": "certificate file reference",
        "default": "",
        "type": "string"
      },
      "emission": {
        "title": "emission timestamp",
        "default": 0,
        "type": "integer"
      },
      "validity": {
        "title": "validity period - months",
        "default": "12",
        "type": "string"
      },
      "expire": {
        "title": "expire timestamp date",
        "default": 0,
        "type": "integer"
      },
      "certificate_authority": {
        "title": "certificate authority",
        "default": "",
        "type": "string"
      },
      "intermediate_certificate_nr": {
        "title": "certificate id",
        "type": "string"
      },
      "intermediate_certificate_ref": {
        "title": "certificate file reference",
        "default": "",
        "type": "string"
      },
      "intermediate_emission": {
        "title": "emission timestamp",
        "default": 0,
        "type": "integer"
      },
      "intermediate_validity": {
        "title": "validity period - months",
        "default": "12",
        "type": "string"
      },
      "intermediate_expire": {
        "title": "expire timestamp date",
        "default": 0,
        "type": "integer"
      },
      "intermediate_certificate_authority": {
        "title": "certificate authority",
        "default": "",
        "type": "string"
      },
      "data": {
        "title": "certificate data",
        "default": {},
        "type": "object"
      },
      "i_class": {
        "title": "primary instrument class",
        "default": "",
        "type": "string"
      },
      "complete": {
        "title": "if primary is complete",
        "default": true,
        "type": "boolean"
      },
      "uom": {
        "title": "primary uom use range",
        "default": "",
        "type": "string"
      },
      "min_use": {
        "title": "primary min use range",
        "default": "",
        "type": "string"
      },
      "max_use": {
        "title": "primary max use range",
        "default": "",
        "type": "string"
      },
      "active": {
        "title": "primary usable for trials",
        "default": true,
        "type": "boolean"
      }
    }
  },
  {
    "title": "PrimaryLoanOp",
    "type": "object",
    "properties": {
      "_id": {
        "title": "Identifier",
        "type": "string"
      },
      "_rev": {
        "title": "Revision number",
        "type": "string"
      },
      "created": {
        "title": "Creation timestamp",
        "type": "integer"
      },
      "updated": {
        "title": "Update timestamp",
        "type": "integer"
      },
      "doc_type": {
        "title": "selector for primary loan",
        "default": "primary_loan",
        "type": "string"
      },
      "created_by": {
        "title": "author user id",
        "default": "",
        "type": "string"
      },
      "updated_by": {
        "title": "doc modifier user id",
        "default": "",
        "type": "string"
      },
      "version": {
        "title": "Version",
        "default": 2,
        "type": "integer"
      },
      "dismissed": {
        "title": "Dismissed",
        "default": false,
        "type": "boolean"
      },
      "instrument_id": {
        "title": "instrument loaned",
        "default": "",
        "type": "string"
      },
      "note": {
        "title": "loan reason",
        "default": "",
        "type": "string"
      },
      "org_id": {
        "title": "owner org_id",
        "default": "",
        "type": "string"
      },
      "used_by": {
        "title": "dest org",
        "default": "",
        "type": "string"
      }
    }
  },
  {
    "title": "Procedure",
    "type": "object",
    "properties": {
      "_id": {
        "title": "Identifier",
        "type": "string"
      },
      "_rev": {
        "title": "Revision number",
        "type": "string"
      },
      "created": {
        "title": "Creation timestamp",
        "type": "integer"
      },
      "updated": {
        "title": "Update timestamp",
        "type": "integer"
      },
      "doc_type": {
        "title": "Doc Type",
        "default": "procedure",
        "type": "string"
      },
      "created_by": {
        "title": "author user id",
        "default": "",
        "type": "string"
      },
      "updated_by": {
        "title": "doc modifier user id",
        "default": "",
        "type": "string"
      },
      "version": {
        "title": "Version",
        "default": 2,
        "type": "integer"
      },
      "dismissed": {
        "title": "Dismissed",
        "default": false,
        "type": "boolean"
      },
      "name": {
        "title": "procedure name",
        "default": "",
        "type": "string"
      },
      "family": {
        "title": "procedure instrument family",
        "default": "",
        "type": "string"
      },
      "op_type": {
        "title": "procedure type of operation",
        "default": "",
        "type": "string"
      },
      "date": {
        "title": "procedure timestamp",
        "default": 0,
        "type": "integer"
      },
      "expiry": {
        "title": "procedure expiration timestamp",
        "default": 0,
        "type": "integer"
      },
      "file_ref": {
        "title": "file ref on filesystem",
        "default": "",
        "type": "string"
      },
      "note": {
        "title": "Procedure notes",
        "default": "",
        "type": "string"
      },
      "active": {
        "title": "procedure active flag",
        "default": false,
        "type": "boolean"
      }
    }
  },
  {
    "title": "Qualification",
    "type": "object",
    "properties": {
      "enabled": {
        "title": "Enabled",
        "default": false,
        "type": "boolean"
      },
      "families": {
        "title": "list of enabled families",
        "default": [],
        "type": "array",
        "items": {
          "type": "string"
        }
      }
    }
  },
  {
    "title": "Range",
    "type": "object",
    "properties": {
      "min": {
        "title": "Min capacity",
        "default": "0",
        "type": "string"
      },
      "max": {
        "title": "Max capacity",
        "default": "",
        "type": "string"
      },
      "e": {
        "title": "homologated resolution(e)",
        "default": "",
        "type": "string"
      },
      "d": {
        "title": "instrument resolution",
        "default": "",
        "type": "string"
      },
      "div_nr": {
        "title": "division number",
        "default": "",
        "type": "string"
      }
    }
  },
  {
    "title": "Report",
    "type": "object",
    "properties": {
      "_id": {
        "title": "Identifier",
        "type": "string"
      },
      "_rev": {
        "title": "Revision number",
        "type": "string"
      },
      "created": {
        "title": "Creation timestamp",
        "type": "integer"
      },
      "updated": {
        "title": "Update timestamp",
        "type": "integer"
      },
      "doc_type": {
        "title": "Doc Type",
        "default": "report",
        "type": "string"
      },
      "created_by": {
        "title": "author user id",
        "default": "",
        "type": "string"
      },
      "updated_by": {
        "title": "doc modifier user id",
        "default": "",
        "type": "string"
      },
      "version": {
        "title": "Version",
        "default": 2,
        "type": "integer"
      },
      "dismissed": {
        "title": "Dismissed",
        "default": false,
        "type": "boolean"
      },
      "operation_id": {
        "title": "operation id",
        "default": "",
        "type": "string"
      },
      "instrument_id": {
        "title": "instrument id",
        "default": "",
        "type": "string"
      },
      "client_id": {
        "title": "client id",
        "default": "",
        "type": "string"
      },
      "location_id": {
        "title": "location id",
        "default": "",
        "type": "string"
      },
      "department_id": {
        "title": "department id",
        "default": "",
        "type": "string"
      },
      "ext_data": {
        "title": "Ext Data",
        "default": {
          "instrument": null,
          "client": null,
          "location": null
        },
        "type": "object"
      },
      "op_type": {
        "title": "report type",
        "default": "",
        "type": "string"
      },
      "code": {
        "title": "report code",
        "default": "",
        "type": "string"
      },
      "on_site_execution": {
        "title": "on site report",
        "default": true,
        "type": "boolean"
      },
      "address_execution": {
        "title": "execution address",
        "default": {
          "address": "",
          "addrNum": "",
          "city": "",
          "zip": "",
          "district": "",
          "country": ""
        },
        "type": "object"
      },
      "pl_reports": {
        "title": "platforms masters and measures",
        "default": {},
        "type": "object"
      },
      "complete": {
        "title": "complete flag",
        "default": false,
        "type": "boolean"
      },
      "owner_id": {
        "title": "owner id",
        "default": "",
        "type": "string"
      },
      "org_id": {
        "title": "org id",
        "default": "",
        "type": "string"
      },
      "primaries": {
        "title": "list of primary instruments used",
        "default": [],
        "type": "array",
        "items": {}
      },
      "other_info": {
        "title": "Other additional info",
        "default": {},
        "type": "object"
      },
      "status": {
        "title": "Report status: new|measuring|completed|closed",
        "default": "new",
        "type": "string"
      },
      "checks": {
        "title": "Report checks",
        "default": {},
        "allOf": [
          {
            "$ref": "#/definitions/ReportCheck"
          }
        ]
      },
      "custom_data": {
        "title": "Data that change based on op_type",
        "default": {},
        "type": "object"
      },
      "report_date": {
        "title": "report date",
        "default": 0,
        "type": "integer"
      },
      "review_date": {
        "title": "review date",
        "default": 0,
        "type": "integer"
      },
      "reviewer": {
        "title": "reviewer id",
        "default": "",
        "type": "string"
      },
      "remarks": {
        "title": "Closing remarks",
        "default": "",
        "type": "string"
      },
      "review_remarks": {
        "title": "Closing review remarks",
        "default": "",
        "type": "string"
      },
      "history": {
        "title": "report review history",
        "default": [],
        "type": "array",
        "items": {}
      },
      "certificate_path": {
        "title": "path to certificate PDF",
        "default": "",
        "type": "string"
      },
      "report_pdf_path": {
        "title": "path to report PDF (GSP leg)",
        "default": "",
        "type": "string"
      },
      "signed_path": {
        "title": "path to signed PDF",
        "default": "",
        "type": "string"
      }
    },
    "definitions": {
      "ReportCheck": {
        "title": "ReportCheck",
        "type": "object",
        "properties": {
          "pdf_ready": {
            "title": "Pdf Ready",
            "default": false,
            "type": "boolean"
          },
          "pdf_sent": {
            "title": "Pdf Sent",
            "default": false,
            "type": "boolean"
          }
        }
      }
    }
  },
  {
    "title": "ReportCheck",
    "type": "object",
    "properties": {
      "pdf_ready": {
        "title": "Pdf Ready",
        "default": false,
        "type": "boolean"
      },
      "pdf_sent": {
        "title": "Pdf Sent",
        "default": false,
        "type": "boolean"
      }
    }
  },
  {
    "title": "Resistence",
    "type": "object",
    "properties": {
      "header": {
        "title": "Header",
        "default": {},
        "type": "object"
      },
      "values": {
        "title": "Resistance values",
        "default": [],
        "type": "array",
        "items": {}
      }
    }
  },
  {
    "title": "SampleModel",
    "type": "object",
    "properties": {
      "_id": {
        "title": "Identifier",
        "type": "string"
      },
      "_rev": {
        "title": "Revision number",
        "type": "string"
      },
      "created": {
        "title": "Creation timestamp",
        "type": "integer"
      },
      "updated": {
        "title": "Update timestamp",
        "type": "integer"
      },
      "doc_type": {
        "title": "Document type",
        "default": "",
        "type": "string"
      },
      "created_by": {
        "title": "author user id",
        "default": "",
        "type": "string"
      },
      "updated_by": {
        "title": "doc modifier user id",
        "default": "",
        "type": "string"
      },
      "version": {
        "title": "doc version",
        "default": 1,
        "type": "integer"
      },
      "dismissed": {
        "title": "Dismissed",
        "default": false,
        "type": "boolean"
      },
      "name": {
        "title": "Name",
        "type": "string"
      },
      "surname": {
        "title": "Surname",
        "type": "string"
      },
      "age": {
        "title": "Age",
        "default": 0,
        "type": "integer"
      },
      "v": {
        "title": "V",
        "default": [],
        "type": "array",
        "items": {
          "type": "integer"
        }
      }
    },
    "required": [
      "name"
    ]
  },
  {
    "title": "SignSyncConfig",
    "type": "object",
    "properties": {
      "_id": {
        "title": "ID",
        "default": "config:sign_sync_data",
        "type": "string"
      },
      "_rev": {
        "title": "Revision number",
        "type": "string"
      },
      "created": {
        "title": "Creation timestamp",
        "type": "integer"
      },
      "updated": {
        "title": "Update timestamp",
        "type": "integer"
      },
      "doc_type": {
        "title": "Doc Type",
        "default": "config",
        "type": "string"
      },
      "created_by": {
        "title": "author user id",
        "default": "",
        "type": "string"
      },
      "updated_by": {
        "title": "doc modifier user id",
        "default": "",
        "type": "string"
      },
      "version": {
        "title": "doc version",
        "default": 1,
        "type": "integer"
      },
      "dismissed": {
        "title": "Dismissed",
        "default": false,
        "type": "boolean"
      },
      "start_push": {
        "title": "time start of copy to shared",
        "default": 0,
        "type": "integer"
      },
      "end_push": {
        "title": "time end of copy to shared",
        "default": 0,
        "type": "integer"
      },
      "status_push": {
        "title": "status of the copy to shared",
        "default": false,
        "type": "boolean"
      },
      "start_pull": {
        "title": "time start of copy back",
        "default": 0,
        "type": "integer"
      },
      "end_pull": {
        "title": "time end of copy back",
        "default": 0,
        "type": "integer"
      },
      "status_pull": {
        "title": "status of the copy back",
        "default": false,
        "type": "boolean"
      }
    }
  },
  {
    "title": "StandardOil",
    "type": "object",
    "properties": {
      "header": {
        "title": "Header",
        "default": {
          "temp": "temperatura",
          "viscosity": "viscosit\u00e0",
          "uncertain": "U incertezza"
        },
        "type": "object"
      },
      "values": {
        "title": "standard oil values",
        "default": [],
        "type": "array",
        "items": {}
      }
    }
  },
  {
    "title": "SummaryTrial",
    "type": "object",
    "properties": {
      "name": {
        "title": "trial name",
        "default": "",
        "type": "string"
      },
      "value": {
        "title": "trial numeric value",
        "default": "",
        "type": "string"
      },
      "tolerance": {
        "title": "trial applied tolerance",
        "default": "",
        "type": "string"
      },
      "result": {
        "title": "trial result",
        "default": false,
        "type": "string"
      },
      "useTolerance": {
        "title": "trial verifies conformity",
        "default": true,
        "type": "boolean"
      }
    }
  },
  {
    "title": "SystemConfig",
    "type": "object",
    "properties": {
      "_id": {
        "title": "Identifier",
        "default": "config:data",
        "type": "string"
      },
      "_rev": {
        "title": "Revision number",
        "type": "string"
      },
      "created": {
        "title": "Creation timestamp",
        "type": "integer"
      },
      "updated": {
        "title": "Update timestamp",
        "type": "integer"
      },
      "doc_type": {
        "title": "Doc Type",
        "default": "config",
        "type": "string"
      },
      "created_by": {
        "title": "author user id",
        "default": "",
        "type": "string"
      },
      "updated_by": {
        "title": "doc modifier user id",
        "default": "",
        "type": "string"
      },
      "version": {
        "title": "Version",
        "default": 2,
        "type": "integer"
      },
      "dismissed": {
        "title": "Dismissed",
        "default": false,
        "type": "boolean"
      },
      "default_org": {
        "title": "reports emission organism",
        "default": "",
        "type": "string"
      },
      "threshold": {
        "title": "threshold dict",
        "default": {
          "type": "month",
          "warning": 2,
          "alert": 1
        },
        "allOf": [
          {
            "$ref": "#/definitions/SystemThreshold"
          }
        ]
      },
      "deadline": {
        "title": "deadline dict",
        "default": {
          "lat": "end_of_month",
          "leg": "expire",
          "iso": "end_of_month",
          "iso_simple": "expire"
        },
        "allOf": [
          {
            "$ref": "#/definitions/SystemDeadline"
          }
        ]
      },
      "report_year": {
        "title": "year to be reported on report code",
        "default": 2024,
        "type": "integer"
      },
      "qrcode": {
        "title": "QRCode config dict",
        "default": {
          "enable_crypt": false,
          "prefixes": [],
          "crypto_key": "",
          "crypto_init_vector": ""
        },
        "allOf": [
          {
            "$ref": "#/definitions/SystemQRCode"
          }
        ]
      },
      "enable_report_code_gen": {
        "title": "enable system report code generation",
        "default": false,
        "type": "boolean"
      },
      "bool": {
        "title": "enable system report code generation",
        "default": false,
        "type": "boolean"
      }
    },
    "definitions": {
      "SystemThreshold": {
        "title": "SystemThreshold",
        "type": "object",
        "properties": {
          "type": {
            "title": "threshold type: month, day, ",
            "default": "month",
            "type": "string"
          },
          "warning": {
            "title": "warning duration",
            "default": 2,
            "type": "integer"
          },
          "alert": {
            "title": "alert duration",
            "default": 1,
            "type": "integer"
          }
        }
      },
      "SystemDeadline": {
        "title": "SystemDeadline",
        "type": "object",
        "properties": {
          "lat": {
            "title": "lat expire type",
            "default": "end_of_month",
            "type": "string"
          },
          "leg": {
            "title": "leg expire type",
            "default": "expire",
            "type": "string"
          },
          "iso": {
            "title": "iso expire type",
            "default": "end_of_month",
            "type": "string"
          },
          "iso_simple": {
            "title": "iso_simple expire type",
            "default": "expire",
            "type": "string"
          }
        }
      },
      "SystemQRCode": {
        "title": "SystemQRCode",
        "type": "object",
        "properties": {
          "enable_crypt": {
            "title": "lat expire type",
            "default": false,
            "type": "boolean"
          },
          "prefixes": {
            "title": "list of URL prefixes",
            "default": [],
            "type": "array",
            "items": {
              "type": "string"
            }
          },
          "crypto_key": {
            "title": "encryption key",
            "default": "",
            "type": "string"
          },
          "crypto_init_vector": {
            "title": "encryption init vector",
            "default": "",
            "type": "string"
          }
        }
      }
    }
  },
  {
    "title": "SystemDeadline",
    "type": "object",
    "properties": {
      "lat": {
        "title": "lat expire type",
        "default": "end_of_month",
        "type": "string"
      },
      "leg": {
        "title": "leg expire type",
        "default": "expire",
        "type": "string"
      },
      "iso": {
        "title": "iso expire type",
        "default": "end_of_month",
        "type": "string"
      },
      "iso_simple": {
        "title": "iso_simple expire type",
        "default": "expire",
        "type": "string"
      }
    }
  },
  {
    "title": "SystemQRCode",
    "type": "object",
    "properties": {
      "enable_crypt": {
        "title": "lat expire type",
        "default": false,
        "type": "boolean"
      },
      "prefixes": {
        "title": "list of URL prefixes",
        "default": [],
        "type": "array",
        "items": {
          "type": "string"
        }
      },
      "crypto_key": {
        "title": "encryption key",
        "default": "",
        "type": "string"
      },
      "crypto_init_vector": {
        "title": "encryption init vector",
        "default": "",
        "type": "string"
      }
    }
  },
  {
    "title": "SystemThreshold",
    "type": "object",
    "properties": {
      "type": {
        "title": "threshold type: month, day, ",
        "default": "month",
        "type": "string"
      },
      "warning": {
        "title": "warning duration",
        "default": 2,
        "type": "integer"
      },
      "alert": {
        "title": "alert duration",
        "default": 1,
        "type": "integer"
      }
    }
  },
  {
    "title": "Temp",
    "type": "object",
    "properties": {
      "_id": {
        "title": "Identifier",
        "type": "string"
      },
      "_rev": {
        "title": "Revision number",
        "type": "string"
      },
      "created": {
        "title": "Creation timestamp",
        "type": "integer"
      },
      "updated": {
        "title": "Update timestamp",
        "type": "integer"
      },
      "doc_type": {
        "title": "object doctype",
        "type": "string"
      },
      "created_by": {
        "title": "author user id",
        "default": "",
        "type": "string"
      },
      "updated_by": {
        "title": "doc modifier user id",
        "default": "",
        "type": "string"
      },
      "version": {
        "title": "doc version",
        "default": 1,
        "type": "integer"
      },
      "dismissed": {
        "title": "Dismissed",
        "default": false,
        "type": "boolean"
      },
      "object": {
        "title": "temporary object",
        "type": "object"
      },
      "o_id": {
        "title": "object id",
        "type": "string"
      },
      "timestamp": {
        "title": "creation timestamp",
        "default": 0,
        "type": "integer"
      },
      "o_rev": {
        "title": "object revision",
        "type": "string"
      }
    }
  },
  {
    "title": "ThermChainOven_PT100",
    "type": "object",
    "properties": {
      "header": {
        "title": "Header",
        "default": {
          "from": "da",
          "to": "a",
          "uncertain": "U incertezza"
        },
        "type": "object"
      },
      "values": {
        "title": "thermo chain oven values",
        "default": [],
        "type": "array",
        "items": {}
      }
    }
  },
  {
    "title": "ThermPressureChain",
    "type": "object",
    "properties": {
      "sensors": {
        "title": "list of obj: {'matricola', 's_type'}",
        "default": [],
        "type": "array",
        "items": {}
      },
      "temp_header": {
        "title": "Temp Header",
        "default": {
          "from": "da",
          "to": "a",
          "un_thermores": "U sonda termometrica",
          "un_thermocoup": "U sonda termocoppia"
        },
        "type": "object"
      },
      "temp_values": {
        "title": "pressure sensor values",
        "default": [],
        "type": "array",
        "items": {}
      },
      "press_header": {
        "title": "Press Header",
        "default": {
          "from": "da",
          "to": "a",
          "uncertain": "U sonda pressione"
        },
        "type": "object"
      }
    }
  },
  {
    "title": "Thermometer",
    "type": "object",
    "properties": {
      "header": {
        "title": "Header",
        "default": {
          "from": "da",
          "to": "a",
          "uncertain": "U incertezza"
        },
        "type": "object"
      },
      "values": {
        "title": "thermometer values",
        "default": [],
        "type": "array",
        "items": {}
      }
    }
  },
  {
    "title": "Tolerance",
    "type": "object",
    "properties": {
      "t_type": {
        "title": "tolerance type manifacturer, user, law",
        "default": "",
        "type": "string"
      },
      "t_vals": {
        "title": "list of tolerances or unique",
        "default": [],
        "type": "array",
        "items": {}
      }
    }
  },
  {
    "title": "ToleranceValues",
    "type": "object",
    "properties": {
      "test_type": {
        "title": "test name | unique",
        "default": "",
        "type": "string"
      },
      "t_calc": {
        "title": "number, perc, formula",
        "default": "",
        "type": "string"
      },
      "t_val": {
        "title": "tolerance value, percentage, formula",
        "type": "number"
      }
    }
  },
  {
    "title": "TrialDict",
    "type": "object",
    "properties": {
      "values_nr": {
        "title": "number of values",
        "default": "0",
        "type": "string"
      },
      "values": {
        "title": "values of the trials",
        "default": [],
        "type": "array",
        "items": {
          "type": "string"
        }
      }
    }
  },
  {
    "title": "TrimmerResistence",
    "type": "object",
    "properties": {
      "header": {
        "title": "Header",
        "default": {},
        "type": "object"
      },
      "values": {
        "title": "Resistance values",
        "default": [],
        "type": "array",
        "items": {}
      }
    }
  },
  {
    "title": "Unit",
    "type": "object",
    "properties": {
      "_id": {
        "title": "Identifier",
        "type": "string"
      },
      "_rev": {
        "title": "Revision number",
        "type": "string"
      },
      "created": {
        "title": "Creation timestamp",
        "type": "integer"
      },
      "updated": {
        "title": "Update timestamp",
        "type": "integer"
      },
      "doc_type": {
        "title": "selector identifier for db",
        "default": "unit",
        "type": "string"
      },
      "created_by": {
        "title": "author user id",
        "default": "",
        "type": "string"
      },
      "updated_by": {
        "title": "doc modifier user id",
        "default": "",
        "type": "string"
      },
      "version": {
        "title": "Version",
        "default": 2,
        "type": "integer"
      },
      "dismissed": {
        "title": "Dismissed",
        "default": false,
        "type": "boolean"
      },
      "name": {
        "title": "Name",
        "type": "string"
      },
      "symbol": {
        "title": "Symbol",
        "type": "string"
      },
      "adempiere_id": {
        "title": "Adempiere internal id",
        "type": "string"
      }
    },
    "required": [
      "name",
      "symbol"
    ]
  },
  {
    "title": "User",
    "type": "object",
    "properties": {
      "external_id": {
        "title": "Idempiere key",
        "default": "",
        "type": "string"
      },
      "external_rev": {
        "title": "idempiere last revision",
        "type": "integer"
      },
      "updated_sync": {
        "title": "last sync time idempiere",
        "default": 0,
        "type": "integer"
      },
      "IE_time": {
        "title": "IE time MUST BE SAME AS UPDATED EACH IE",
        "type": "integer"
      },
      "ide_conflict": {
        "title": "if there is a conflict with idempiere",
        "default": false,
        "type": "boolean"
      },
      "_id": {
        "title": "Identifier",
        "type": "string"
      },
      "_rev": {
        "title": "Revision number",
        "type": "string"
      },
      "created": {
        "title": "Creation timestamp",
        "type": "integer"
      },
      "updated": {
        "title": "Update timestamp",
        "type": "integer"
      },
      "doc_type": {
        "title": "selector identifier for db",
        "default": "user",
        "type": "string"
      },
      "created_by": {
        "title": "author user id",
        "default": "",
        "type": "string"
      },
      "updated_by": {
        "title": "doc modifier user id",
        "default": "",
        "type": "string"
      },
      "version": {
        "title": "Version",
        "default": 3,
        "type": "integer"
      },
      "dismissed": {
        "title": "Dismissed",
        "default": false,
        "type": "boolean"
      },
      "name": {
        "title": "name of the user",
        "type": "string"
      },
      "code": {
        "title": "user code",
        "default": "",
        "type": "string"
      },
      "report_seq": {
        "title": "report sequences",
        "default": {
          "N": 0,
          "A": 0,
          "iso": 0,
          "iso_simple": 0,
          "humidity": 0,
          "doserL": 0,
          "lat": 0
        },
        "type": "object"
      },
      "phone": {
        "title": "phone number",
        "type": "string"
      },
      "username": {
        "title": "username for login",
        "default": "",
        "type": "string"
      },
      "email": {
        "title": "email of the user, old login",
        "type": "string"
      },
      "password": {
        "title": "hashed pwd",
        "type": "string"
      },
      "salt": {
        "title": "field to save the salt for hashed PW",
        "type": "string"
      },
      "roles": {
        "title": "list of user roles",
        "default": [],
        "type": "array",
        "items": {
          "type": "string"
        }
      },
      "org_id": {
        "title": "id of the organization",
        "type": "string"
      },
      "report_type": {
        "title": "report types qualifications",
        "default": {
          "leg": {
            "enabled": false,
            "families": []
          },
          "iso": {
            "enabled": false,
            "families": []
          },
          "iso_simple": {
            "enabled": false,
            "families": []
          },
          "lat": {
            "enabled": false,
            "families": []
          }
        },
        "type": "object"
      },
      "review_type": {
        "title": "report types qualifications",
        "default": {
          "leg": {
            "enabled": false,
            "families": []
          },
          "iso": {
            "enabled": false,
            "families": []
          },
          "iso_simple": {
            "enabled": false,
            "families": []
          },
          "lat": {
            "enabled": false,
            "families": []
          }
        },
        "type": "object"
      },
      "domain": {
        "title": "User domain",
        "type": "string"
      },
      "sign_ref": {
        "title": "user sign image ref",
        "default": "",
        "type": "string"
      },
      "avatar_ref": {
        "title": "user avatar image ref",
        "default": "",
        "type": "string"
      },
      "notes": {
        "title": "user notes",
        "default": "",
        "type": "string"
      }
    }
  },
  {
    "title": "WeightSet",
    "type": "object",
    "properties": {
      "w_type": {
        "title": "weight set type",
        "default": "",
        "type": "string"
      },
      "w_model": {
        "title": "weight set model",
        "default": "",
        "type": "string"
      },
      "w_manifacturer": {
        "title": "weight set manifacturer",
        "default": "",
        "type": "string"
      },
      "w_class": {
        "title": "weight set class",
        "default": "",
        "type": "string"
      },
      "header": {
        "title": "Header",
        "default": {
          "_id": "matricola/identificativo",
          "name": "valore nominale",
          "conv": "valore convenzionale",
          "uncertain_ext": "U incertezza",
          "manufacturer": "costruttore",
          "class": "classe OIML"
        },
        "type": "object"
      },
      "values": {
        "title": "weight set values",
        "default": [],
        "type": "array",
        "items": {}
      },
      "uom": {
        "title": "uom of the weight set",
        "default": "",
        "type": "string"
      },
      "weightTotal": {
        "title": "sum of all weights",
        "default": 0,
        "type": "number"
      },
      "min_weight": {
        "title": "min nom value",
        "default": 0,
        "type": "number"
      },
      "max_weight": {
        "title": "max nom value",
        "default": 0,
        "type": "number"
      },
      "min_u": {
        "title": "min u_ext value",
        "default": 0,
        "type": "number"
      },
      "max_u": {
        "title": "max u_ext value",
        "default": 0,
        "type": "number"
      }
    }
  }
]